// Define page-specific action types to avoid conflicts with item actions
export const PAGE_ACTION_TYPES = {
  FETCH_PAGES: 'FETCH_PAGES',
  FETCH_PAGE: 'FETCH_PAGE',
  GET_MORE_PAGES: 'GET_MORE_PAGES',
  SET_LOADING_STATE: 'PAGE_SET_LOADING_STATE',
  SET_ERROR_STATE: 'PAGE_SET_ERROR_STATE'
};

const initialState = {
  pages: [],
  currentPage: null,
  paginationInfo: {
    hasNextPage: false,
    endCursor: null,
    collectionHandle: null,
    searchTerm: null
  },
  isLoading: false,
  error: null
};

export default function pageReducer(state = initialState, action: any) {
  switch (action.type) {
    case PAGE_ACTION_TYPES.FETCH_PAGES:
      return {
        ...state,
        pages: action.payload,
        currentPage: null,
        paginationInfo: action.paginationInfo || state.paginationInfo,
        error: null
      };
    case PAGE_ACTION_TYPES.FETCH_PAGE:
      return {
        ...state,
        currentPage: action.payload,
        error: null
      };
    case PAGE_ACTION_TYPES.GET_MORE_PAGES:
      return {
        ...state,
        pages: [...state.pages, ...action.payload],
        paginationInfo: action.paginationInfo || state.paginationInfo,
        error: null
      };
    case PAGE_ACTION_TYPES.SET_LOADING_STATE:
      return {
        ...state,
        isLoading: action.isLoading
      };
    case PAGE_ACTION_TYPES.SET_ERROR_STATE:
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
}
